var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"logout"},[_c('p',[_vm._v("Vous êtes correctement déconnecté de l'application Objectif RGE.")])])
}]

export { render, staticRenderFns }